<script setup>
name: 'blogAuthorPage'
const route = useRoute()
const { getBlogSettings, getAuthorBySlug, getPosts } = useBlogData()
const { setPageHead } = useGlobalFeaturesData();

definePageMeta({
  layout: "blog",
});

// Temporary geetting the first page created
const { data: settings, error: settingsError } = await getBlogSettings();

const { data: author, error: authorError } = await getAuthorBySlug(route.params.slug);
if (authorError.value) {
  throw createError({ statusCode: 404, statusMessage: authorError.value })
}

// Default sort of posts
let paramsString = `?sort=publishedAt:DESC&pagination[page]=1&pagination[pageSize]=6&pagination[withCount]=true&filters[author][slug][$eqi]=${route.params.slug}`
// Adjusts posts to get the first one on top and pass others to reel
const { data: postsReel, error: postsError } = await getPosts(paramsString)

// On this page we get the first posts so it is on the bigger section with the featured posts on the side
let postsArr = postsReel.value.data

// Sections dynamic builder variable
const sections = author.value && author.value.blocks ? author.value.blocks : []
// Jump to top option
const displayJumpToTop = author.value.jumpToTop;

</script>

<template>
  <BlogCategories />
  <section class="author-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="breadcrumb">
            <NuxtLink class="breadcrumb-element" :href="`/blog`">Blog</NuxtLink>
            <span class="breadcrumb-element">></span>
            <span class="breadcrumb-element" v-html="author.name"></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-1">
          <div :style="`background-image: url(${author.image.url})`" class="author-image"></div>
        </div>
        <div class="col-12 col-lg-11">
          <h1 class="author-name" v-html="author.name"></h1>
          <NuxtLink :href="author.linkedIn" class="author-linkedin"><i class="icon-sm-linkedin"></i></NuxtLink>
          <article class="author-background" v-html="author.background"></article>
        </div>
      </div>
    </div>
  </section>
  <section class="blog-reel">
    <BlogPostsReel :posts="postsArr" :meta="postsReel.meta" :nextItem="7" :filters="`filters[author][slug][$eqi]=${route.params.slug}`"/>
  </section>
  <LayoutDynamicComponents v-if="sections" :sections="sections" />
  <LayoutBackToTop v-if="displayJumpToTop" />
</template>

<style lang="scss">
.breadcrumb{
  font-size: $font-size-smaller;
  a{
    font-weight: bold;
  }
  .breadcrumb-element{
    color: $color-primary;
    display: inline-block;
    &:not(:last-child){
      margin-right: 10px;
    }
  }
}
.author-page{
  .author-image{
    width: 108px;
    height: 108px;
    background: no-repeat center;
    background-size: cover;
    border-radius: 50%;
  }
  .author-name{
    display: inline-block;
    margin-left: 10px;
  }
  .author-linkedin{
    font-size: 1.5rem;
    margin-left: 15px;
    text-decoration: none;
    color: #007bb6;
    cursor: pointer;
  }
  .author-background {
    margin-left: 10px;
  }
}
.blog-reel{
  padding-bottom: 40px;
}
@include media-breakpoint-up(lg){
  .blog-reel{
    padding-top: 40px;
  }
}
</style>